import { LinkInterface } from '@/domain/interface/LinkInterface';
import { Gebouw } from '@/domain/interface/melding/Gebouw';

export class MeldingClass {
  id: string;
  meldingsnummer: string;
  gebouw: Gebouw;
  links: LinkInterface;
  readOnly: boolean;
  zelfingegevenAdres: boolean;
  telefoonnummer: string;
  email: string;

  constructor(melding?: MeldingClass) {
    this.id = melding?.id || '';
    this.meldingsnummer = melding?.meldingsnummer || '';
    this.gebouw = new Gebouw(melding?.gebouw);
    this.links = melding?.links || {};
    this.readOnly = melding?.readOnly || false;
    this.zelfingegevenAdres = melding?.zelfingegevenAdres;
    this.telefoonnummer = melding?.telefoonnummer;
    this.email = melding?.email;
  }
}
